/* Shop The Occasion
   The occasion list uses native <details>/<summary> with name="..." for
   exclusive accordion behavior. This script syncs the right-hand image panel
   (lifestyle image + floating product card) to whichever occasion is open,
   reading the data-occasion-* attributes the Liquid emits on each <details>. */
(function () {
  'use strict';

  function initSection(section) {
    var occasions = section.querySelectorAll('.oddit-section-shop-the-occasion__occasion');
    if (!occasions.length) return;

    var image = section.querySelector('.oddit-section-shop-the-occasion__lifestyle-image');
    var card = section.querySelector('[data-product-card]');
    var cardThumb = section.querySelector('.oddit-section-shop-the-occasion__product-thumb');
    var cardTitle = section.querySelector('[data-product-title]');
    var cardPrice = section.querySelector('[data-product-price]');

    function applyOccasion(details) {
      if (!details) return;

      var imageUrl = details.getAttribute('data-occasion-image');
      if (image && imageUrl) {
        image.src = imageUrl;
        // Remove srcset so the browser honours the swapped src.
        image.removeAttribute('srcset');
      }

      if (!card) return;

      var productUrl = details.getAttribute('data-occasion-product-url');
      if (productUrl) {
        card.hidden = false;
        card.style.display = '';
        card.setAttribute('href', productUrl);

        var title = details.getAttribute('data-occasion-product-title');
        if (cardTitle && title) {
          cardTitle.textContent = title;
          card.setAttribute('aria-label', 'View ' + title);
        }

        var price = details.getAttribute('data-occasion-product-price');
        if (cardPrice && price) cardPrice.textContent = price;

        var thumbUrl = details.getAttribute('data-occasion-product-image');
        if (cardThumb && thumbUrl) {
          cardThumb.src = thumbUrl;
          cardThumb.removeAttribute('srcset');
        }
      } else {
        // Occasion has no featured product — hide the card.
        card.hidden = true;
        card.style.display = 'none';
      }
    }

    occasions.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) applyOccasion(details);
      });
    });

    // Sync to whichever occasion is open on load (first by default).
    var openOnLoad = section.querySelector('.oddit-section-shop-the-occasion__occasion[open]') || occasions[0];
    applyOccasion(openOnLoad);
  }

  function init() {
    document.querySelectorAll('.oddit-section-shop-the-occasion').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
